import { render, staticRenderFns } from "./platformReportRecord.vue?vue&type=template&id=3c13b2b2&scoped=true"
import script from "./platformReportRecord.vue?vue&type=script&lang=js"
export * from "./platformReportRecord.vue?vue&type=script&lang=js"
import style0 from "./platformReportRecord.vue?vue&type=style&index=0&id=3c13b2b2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c13b2b2",
  null
  
)

export default component.exports